/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.


const config = {
    "wip": {
        Auth: {
            mandatorySignIn: true,
            region: 'us-east-1',
            userPoolId: 'us-east-1_qZh2lcP9V',
            userPoolWebClientId: '671r0k3cqkt3v19641arf8k2gb',
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {}
        },
        aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://ihlvsimks5ezvf3nhocxscir4u.appsync-api.us-east-1.amazonaws.com/graphql'
    },
    "uat": {
        Auth: {
            mandatorySignIn: true,
            region: 'us-east-1',
            userPoolId: 'us-east-1_z7nGKmCyP',
            userPoolWebClientId: '4df1hsh5j7qtqs22h4f729t3t9',
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {}
        },
        aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://36hxcoie7nffhclcwq5hd3uhwu.appsync-api.us-east-1.amazonaws.com/graphql'
    },
    "prod": {
        Auth: {
            mandatorySignIn: true,
            region: 'us-east-1',
            userPoolId: 'us-east-1_z7nGKmCyP',
            userPoolWebClientId: '4df1hsh5j7qtqs22h4f729t3t9',
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {}
        },
        aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_region: 'us-east-1',
        aws_appsync_graphqlEndpoint: 'https://2buytaaxrzgi3kvnr45ki3hcde.appsync-api.us-east-1.amazonaws.com/graphql'
    }
}

export default config[process.env.REACT_APP_ENV];
